<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    width="51.7377mm"
    height="32.3527mm"
    version="1.1"
    style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
    viewBox="0 0 1458.71 912.17"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <style type="text/css">
        <![CDATA[
         .fil0 {fill:#373435}
        ]]>
      </style>
    </defs>
    <g id="Camada_x0020_1">
      <metadata id="CorelCorpID_0Corel-Layer" />
      <path
        class="fil0"
        d="M460.01 4.64l649 0c59.8,0 108.69,48.89 108.69,108.69l0 0c0,59.8 -48.89,108.69 -108.69,108.69l-649 0 -108.69 -108.69 0 0 108.69 -108.69zm0 343.4l890.02 0c59.8,0 108.69,48.89 108.69,108.69l0 0c0,59.79 -48.91,108.69 -108.69,108.69l-890.02 0 -108.69 -108.69 0 0 108.69 -108.69zm0 341.82l401.69 0c59.79,0 108.69,48.89 108.69,108.69l0 0c0,59.79 -48.96,108.69 -108.69,108.69l-401.69 0 -108.69 -108.69 0 0 108.69 -108.69zm-346.59 -689.86c62.63,0 113.43,50.8 113.43,113.43 0,62.63 -50.8,113.43 -113.43,113.43 -62.63,0 -113.42,-50.8 -113.42,-113.43 0,-62.63 50.79,-113.43 113.42,-113.43zm0 343.32c62.63,0 113.43,50.8 113.43,113.43 0,62.63 -50.8,113.43 -113.43,113.43 -62.63,0 -113.42,-50.8 -113.42,-113.43 0,-62.63 50.79,-113.43 113.42,-113.43zm0 341.99c62.63,0 113.43,50.8 113.43,113.42 0,62.63 -50.8,113.43 -113.43,113.43 -62.63,0 -113.42,-50.8 -113.42,-113.43 0,-62.63 50.79,-113.42 113.42,-113.42z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IcoHome',
}
</script>
